import { cva, type VariantProps } from "class-variance-authority";

export const dialogContentVariants = cva(
  [
    "bg-base-100 fixed grid gap-4 w-full rounded-xl border p-6 shadow-lg",
    // sizing,
    "max-h-[calc(100dvh-2rem)] max-w-[calc(100dvw-2rem)]",
    // positioning
    "top-[50%] left-[50%] z-50 translate-x-[-50%] translate-y-[-50%]",
    // animation
    "duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95",
  ],
  {
    variants: {
      size: {
        default: "sm:max-w-xl",
        large: "sm:max-w-3xl",
        // grid-rows here assumes three child elements in this order: DialogHeader, {body}, DialogFooter
        fullScreen:
          "lg:max-w-[calc(100%-2rem)] rounded-none lg:rounded-xl lg:max-h-[calc(100%-2rem)] grid-rows-[auto_1fr_auto] max-h-dvh h-dvh max-w-dvw w-dvw",
      },
    },
    defaultVariants: {
      size: "default",
    },
  },
);
export type DialogContentVariants = VariantProps<typeof dialogContentVariants>;
export const dialogOverlayVariants = cva(
  "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 bg-overlay/80 fixed inset-0 z-50",
);
